import { create } from 'zustand';
export interface Toast { id: number; text: string; kind: 'info' | 'ok' | 'err' }
let n = 0;
export const useToasts = create<{ items: Toast[]; push: (text: string, kind?: Toast['kind']) => void; drop: (id: number) => void }>((set) => ({
  items: [],
  push: (text, kind = 'info') => { const id = ++n; set((s) => ({ items: [...s.items.slice(-4), { id, text, kind }] })); setTimeout(() => set((s) => ({ items: s.items.filter((t) => t.id !== id) })), 3500); },
  drop: (id) => set((s) => ({ items: s.items.filter((t) => t.id !== id) })),
}));
export const toast = (text: string, kind?: Toast['kind']) => useToasts.getState().push(text, kind);
